import { Component, OnInit, ViewChild } from '@angular/core';
import {
  Router,
  ActivatedRoute,
  Params,
  NavigationExtras,
} from '@angular/router';
import { AbstractControl, NgForm } from '@angular/forms';

import * as HttpStatus from 'http-status-codes';
import * as $ from 'jquery';

import { SignupForm } from './signup-form';
import { LoginComponent } from '../login/login.component';

import { UsersService } from '../../services/users.service';
import { MainService } from 'app/services/main.service';

import { Helper } from '../../helper';
import { Constants } from '../../constants';

const _ = require('underscore');

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss'],
})
export class SignupComponent implements OnInit {
  API = this.helper.getApi();
  errorIcon = 'assets/icons/exclamation-mark.svg';
  formElements: SignupForm<any>[] = [];
  dropdownSelection = [];
  submitted = false;
  validationNumber: number;
  notification = { message: '', type: '' };
  allClinics: any;
  currentClinicId: any;
  currentDanmNr: any;
  currentUserName: any;
  currentNationality: any;
  currentInsuranceCompany: any;
  clinics = '';
  insurances = this.helper.getInsurance();
  helperDrpdwKeys = [];
  validity: 'false';
  formLoaded = false;
  preselectedClinic: string;
  superClinicId: string;
  cpr: string;
  surname: string;
  email: string;
  phone: string;
  name: string;
  service: string;
  type: string;
  singleClinic: string;
  aalborgFlow: boolean;
  bookingToken: string;
  correctCpr: boolean;
  signup_details: any = this.helper.getStorage('signup_details');
  readonly zipCodeList: any = Constants.ZIP_CODES;
  readonly countries: any = Constants.COUNTRIES;
  readonly groups: any = Constants.GROUPS;
  readonly flowName: any = Constants.FLOW_TYPE;

  @ViewChild('signupForm') signupForm: NgForm;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public helper: Helper,
    public usersService: UsersService,
    public mainService: MainService,
    public loginComponent: LoginComponent
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params: Params) => {
      this.clinics = params.clinics;
      this.superClinicId = params.superClinicId;
      this.service = params.service;
      this.type = params.type;
      this.bookingToken = params.bookingToken;
      this.singleClinic = params.singleClinic;

      this.aalborgFlow = params.type === this.flowName.aalborg;

      if (params.cpr) {
        this.cpr = params.cpr;
      }

      if(this.aalborgFlow == true && !this.signup_details && this.bookingToken){
        let redirectParams = {
          type: this.type,
          service: this.service,
          superClinicId: this.superClinicId,
          singleClinic: this.singleClinic
        };

        this.router.navigate(['..'], { queryParams: redirectParams });
      }

      // Prefill form if have signup details after login with bookingToken
      if (!this.bookingToken) {
        localStorage.clear();
      } else {

        if (this.signup_details) {

          if (this.signup_details.cprNr) {
            this.cpr = this.signup_details.cprNr; 
          }

          if (this.signup_details.lastName) {
            this.surname = this.signup_details.lastName;
          }

          if (this.signup_details.email) {
            this.email = this.signup_details.email;
          }

          if (this.signup_details.cellNr) {
            this.phone = this.signup_details.cellNr;
          }

          if (this.signup_details.firstName) {
            this.name = this.signup_details.firstName;
          }
        }
      }
    });

    this.mainService
      .getClinics()
      .subscribe(this.handleClinicsSuccess.bind(this));
  }

  handleClinicsSuccess(clinicsResponse) {
    clinicsResponse.map((el) => {
      _.extend(el, { _id: el.id });
    });

    this.allClinics = clinicsResponse;
    this.allClinics = clinicsResponse.filter((el) => el.is_super_clinic === false && el.fbooking_flow == 1 && el.general_flow == 1);
  

    if (this.clinics) {
      this.allClinics = clinicsResponse.filter((el) => el.id === this.clinics && el.fbooking_flow == 1 && el.general_flow == 1);
      if(this.singleClinic && this.singleClinic == 'true'){
        this.allClinics = clinicsResponse;
     }
    }

    if (this.superClinicId) {
      this.allClinics = clinicsResponse.filter(
        (el) => el.super_clinic_id === this.superClinicId && el.fbooking_flow == 1
      );
    }

    // Sort all clinics by post code
    this.allClinics = _.sortBy(this.allClinics, 'post_code');

    this.saveClinicsToStorage(clinicsResponse);
    this.generateForm();

    this.formLoaded = true;
  }

  generateForm() {
    let clinics;
    let selected_clinic;
    let single_clinic = false;
    let clinic_element;

    if (this.superClinicId) {
      clinics = this.allClinics
        .filter((el) => el.super_clinic_id === this.superClinicId)
        .map((clinic) => {
          return { key: clinic.id, value: clinic.name };
        });
    } else if (this.clinics) {
      clinics = this.allClinics
        .filter((el) => el.id === this.clinics)
        .map((clinic) => {
          return { key: clinic.id, value: clinic.name };
        });

      single_clinic = true;

      selected_clinic = this.allClinics.filter((el) => el.id === this.clinics);
    } else {
      clinics = this.allClinics.map((clinic) => {
        return { key: clinic.id, value: clinic.name };
      });
    }

    if (single_clinic) {
      clinic_element = {
        key: 'clinicId',
        label: 'Klinik',
        required: !this.aalborgFlow,
        controlType: 'text',
        value: selected_clinic[0].name,
      };
    } else {
      clinic_element = {
        key: 'clinicId',
        label: 'Klinik',
        required: !this.aalborgFlow,
        controlType: 'dropdown',
        vals: clinics,
      };
    }

    // Hide "FysioDanmark Aalborg" clinic if aalborg flow
    if (this.aalborgFlow) {
      clinics = clinics.filter(
        (el) => el.key !== '00000a00ca09000007d1120700000163248870d75296ee49'
      );
    }

    this.formElements = [
      new SignupForm(clinic_element),
      new SignupForm({
        key: 'cprNr',
        label: 'CPR-nr.',
        required: true,
        value: this.cpr,
        controlType: 'text',
        pattern:
          '(?:0[1-9]|[12][0-9]|3[01])(?:0[1-9]|1[012])(?:[0-9]{2})-?[0-9]{4}',
        errors: {
          pattern: 'Skriv CPR som 10 cifre uden skilletegn.',
          custom: 'Ugyldigt CPR',
        },
      }),
      new SignupForm({
        key: 'firstName',
        value: this.name,
        label: 'Fornavn',
        required: true,
        controlType: 'text',
        errors: { pattern: 'Fornavn skal udfyldes!' },
      }),
      new SignupForm({
        key: 'lastName',
        label: 'Efternavn',
        value: this.surname,
        required: true,
        controlType: 'text',
        errors: { pattern: 'Efternavn skal udfyldes' },
      }),
      new SignupForm({
        key: 'address',
        label: 'Adresse',
        required: true,
        controlType: 'text',
        pattern: '[a-zA-Z0-9 .,-ÅåÆæØø]{2,}',
        errors: { pattern: 'Adresse skal udfyldes!' },
      }),
      new SignupForm({
        key: 'postalNr',
        label: 'Postnummer',
        required: true,
        controlType: 'text',
        pattern: '',
        errors: { pattern: 'Postnummer skal udfyldes!' },
      }),
      new SignupForm({
        key: 'city',
        label: 'By',
        required: true,
        controlType: 'text',
        pattern: '[a-zA-Z0-9 .,-åæéøÅÆÉØ]{2,}',
        errors: { pattern: 'By skal udfyldes!' },
      }),
      new SignupForm({
        key: 'nationality',
        label: 'Nationalitet',
        required: true,
        controlType: 'dropdown',
        errors: { pattern: 'Nationalitet skal udfyldes!' },
        vals: this.countries,
      }),
      new SignupForm({
        key: 'email',
        label: 'Email',
        value: this.email,
        required: true,
        controlType: 'email',
        pattern: '[a-zA-Z0-9_\\.\\+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-\\.]+',
        errors: {
          pattern:
            "Email skal udfyldes og skal formateres 'adresse@domain.xx'!",
        },
      }),
      new SignupForm({
        key: 'cellNr',
        label: 'Mobil',
        required: true,
        value: this.phone,
        controlType: 'number',
        pattern: '[0-9+-]{6,18}',
        errors: { pattern: 'Mobil tlf. skal udfyldes!' },
      }),
      new SignupForm({
        key: 'phoneNr',
        label: 'Telefon',
        required: false,
        controlType: 'number',
        pattern: '[0-9+-]{6,18}',
        errors: { pattern: 'Telefon skal udfyldes!' },
      }),
      new SignupForm({
        key: 'danmNr',
        label: 'Danmarksgruppe',
        required: true,
        controlType: 'dropdown',
        vals: this.groups,
      }),
      new SignupForm({
        key: 'insuranceCompany',
        label: 'Sundhedsforsikring, hvis ja, hvilken?',
        required: false,
        controlType: 'dropdown',
        vals: this.insurances,
      }),
      new SignupForm({
        key: 'username',
        label: 'Brugernavn',
        required: this.aalborgFlow ? false : true,
        controlType: 'text',
        pattern: '[a-zA-Z0-9_-]{2,20}',
        errors: {
          pattern:
            'Brugernavn skal idfyldes - og kan indeholde Store og små bogstaver, tal, og special-tegn!',
        },
      }),
      new SignupForm({
        key: 'password',
        label: 'Kodeord',
        required: true,
        controlType: 'password',
        pattern: '[a-zA-Z0-9_-]{7,}',
        errors: {
          pattern:
            'Kodeord skal udfyldes og skal indeholde min. 7 store og/eller små bogstaver og/eller cifre!',
        },
      }),
      new SignupForm({
        key: 'repeatPassword',
        label: 'Kodeord gentag',
        required: true,
        controlType: 'password',
        pattern: '[a-zA-Z0-9_-]{7,}',
        errors: {
          pattern:
            'Kodeord skal udfyldes og skal indeholde min. 7 store og/eller små bogstaver og/eller cifre!',
        },
      }),
    ];

    this.validationNumber = this.generateValidationNum(100000, 999999);

    this.setDropdownSelection('Danmark', 'preselect_country', {
      value: 'Danmark',
      key: 'DK',
    });
  }

  saveClinicsToStorage(clinics) {
    localStorage.setItem('allClinics', JSON.stringify(clinics));
  }

  generateValidationNum(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  setDropdownSelection(event: any, formElement: any, data: any) {
    let item;

    if (formElement === 'preselect_country') {
      item = {
        key: 'nationality',
        value: 'Danmark',
        data: 'DK',
        default: 'Nationalitet',
      };

      formElement = this.formElements[7];
      formElement.value = 'Danmark';
    } else {
      formElement.value =
        formElement.key === 'clinicId' ? data.key : data.value;

      item = {
        key: formElement.key,
        value: data.value,
        data: data.key,
        default: formElement.label,
      };
    }

    const dropdownItem = item;

    if (
      this.dropdownSelection.filter((e) => e.key === dropdownItem.key).length >
      0
    ) {
      this.dropdownSelection.map((elem, i) => {
        if (elem.key === dropdownItem.key) {
          this.dropdownSelection[i] = dropdownItem;
          this.helperDrpdwKeys[i] = dropdownItem.key;
        }
      });
    } else {
      this.dropdownSelection.push(dropdownItem);
      this.helperDrpdwKeys.push(dropdownItem.key);
    }

    this.notification = { message: null, type: null };
  }

  signupUser() {
    this.notification = { message: null, type: null };

    document.querySelector('.section-title').scrollIntoView({
      behavior: 'smooth',
    });

    const isFormInvalid = this.validateFormInputs();

    if (isFormInvalid) {
      return;
    }

    if (!this.aalborgFlow) {
      this.currentClinicId = _.find(this.dropdownSelection, function (
        selection
      ) {
        return selection.key === 'clinicId';
      });

      this.currentDanmNr = _.find(this.dropdownSelection, function (selection) {
        return selection.key === 'danmNr';
      });

      this.currentInsuranceCompany = _.find(this.dropdownSelection, function (
        selection
      ) {
        return selection.key === 'insuranceCompany';
      });

      if (this.currentClinicId === undefined && !this.clinics) {
        this.notification = { message: 'Vælg klinik!', type: 'error' };

        return;
      }
    }

    const cprNr = this.formElements.find((fe) => fe.key === 'cprNr');

    if (!cprNr.value || !cprNr.value.trim().length) {
      this.notification = { message: cprNr.errors.pattern, type: 'error' };
      return;
    }

    if (!this.aalborgFlow) {
      if (this.currentDanmNr === undefined) {
        this.notification = { message: 'Vælg Danmarksgruppe!', type: 'error' };

        return;
      }
    }

    // if single clinic flow, pass clinic id from param
    let clinic_id;

    if (this.aalborgFlow) {
      clinic_id = '';
    } else {
      if (this.clinics) {
        clinic_id = this.clinics;
      } else {
        clinic_id = this.currentClinicId
          ? this.currentClinicId.data
          : undefined;
      }
    }

    const data = {
      isEmailRemainder: $('#checkbox-option-1').is(':checked'),
      isEmailRemainderGroup: $('#checkbox-option-2').is(':checked'),
      isSMSRemainder: $('#checkbox-option-3').is(':checked'),
      isSMSRemainderGroup: $('#checkbox-option-4').is(':checked'),
      clinicId: clinic_id,
      flow_url: window.location.search,
      nationality: 'Denmark',
    };

    this.formElements.map((el) => {
      if (el.key === 'clinicId') {
        data['clinicName'] = el.value;
      } else {
        data[el.key] = el.value;
      }
    });

    if (data['password'] !== data['repeatPassword']) {
      this.notification = {
        message: 'De indtastede kodeord matcher ikke.',
        type: 'error',
      };
      return;
    }

    const user_entered_nr = $('#validation-number-user').val();
    const validation_code = $('#validation-generated').attr('data-generated');

    if (user_entered_nr !== validation_code) {
      this.notification = {
        message: 'Indtast det seks-cifrede nummer der står på den grønne knap.',
        type: 'error',
      };

      return;
    }

    const is_terms = $('#checkbox-terms').is(':checked');

    if (is_terms) {
      if (this.aalborgFlow) {
        data['danmNr'] = 'Ingen';
        data['clinicId'] = '00000a00ca09000007d1120700000163248870d75296ee49';
      }

      const cpr = data['cprNr'].replace('-', '').substr(0, 10);

      data['cprNr'] = cpr;
      data['username'] = cpr;

      this.usersService
        .signup(data)
        .subscribe(this.handleSuccess.bind(this, data));
    } else {
      this.notification = {
        message: 'Accepter venligst privatlivspolitik!',
        type: 'error',
      };
    }
  }

  validateFormInputs(): boolean {
    const ignoredFields = ['cprNr', 'username'];
    let isInvalid = false;

    for (const formElement of this.formElements) {
      console.log(formElement.key);
      console.log(formElement.value);

      if (ignoredFields.indexOf(formElement.key) > -1) {
        continue;
      }

      const control = this.signupForm.controls[formElement.key];

      if (!control) {
        continue;
      }

      if (
        formElement.required &&
        (!formElement.value || !formElement.value.trim().length)
      ) {
        isInvalid = true;
        control.markAsTouched();
        control.markAsDirty();
      } else {
        control.markAsUntouched();
        control.markAsPristine();
      }
    }

    return isInvalid;
  }

  handleSuccess(data, signupResponse) {
    if (signupResponse.status === HttpStatus.OK) {
      this.notification = {
        message: 'Signup Vellykket',
        type: 'success',
      };

      const params = {
        clinics: this.clinics,
        superClinicId: this.superClinicId,
        service: this.service,
        type: this.type ? this.type : 'fysiq',
        singleClinic: !!this.clinics,
      };

      this.loginComponent.login(
        'register',
        { email: data['cprNr'], password: data['password'] },
        params
      );
    } else {
      this.notification = {
        message:
          'Dit indtastede CPR-nr. eller e-mail eksisterer allerede i systemet. ' +
          'Gå venligst tilbage til log ind-siden for at logge ind. Hvis du har glemt eller ikke har et kodeord, ' +
          'kan det genskabes via log ind-siden. ' +
          'Oplever du fortsat problemer med at logge ind, kontakt den klinik som du ønsker at benytte.',
        type: 'error',
      };
    }
  }

  checkInputFilled(
    event: any,
    form: { [key: string]: AbstractControl },
    key: string,
    element: SignupForm<any>
  ) {
    element.valid = form[key].status;

    if (key === 'postalNr') {
      const filtered = this.zipCodeList.filter(
        (el) => el.zip === form[key].value
      );
      const city = filtered.length === 1 ? filtered[0].city : '';
      const cityElement = document.getElementById('city');

      this.formElements
        .filter((el) => el.key === 'city')
        .map((el) => el.value === city);

      if (event.target.value !== '' && filtered.length === 1) {
        cityElement.parentElement.classList.add('input--filled');

        form['city'].updateValueAndValidity();
        form['city'].markAsTouched();
        form['city'].markAsDirty();
      } else {
        cityElement.parentElement.classList.remove('input--filled');
      }
    }

    const parent_class = event.target.parentNode.classList;

    if (key === 'cellNr') {
      parent_class.add('input--filled');
    } else {
      if (event.target.value !== '') {
        parent_class.add('input--filled');
      } else {
        parent_class.remove('input--filled');
      }
    }

    if (key === 'cprNr') {
      event.target.value = event.target.value.substr(0, 10);
    }
  }

  onKey(event: any, key) {
    if (key === 'cprNr') {
      event.target.value = event.target.value.replace(/[^\d]/, '');

      if (event.target.value.length > 10) {
        event.target.value = event.target.value.substr(0, 10);
      }

      if (this.helper.validateCpr(event.target.value)) {
        this.correctCpr = true;
      } else {
        this.correctCpr = false;
      }
    }
  }

  goToPolicy() {
    const params = {
      type: this.type,
      service: this.service,
      singleClinic: this.singleClinic,
    };

    // if superclinic and superclinic + service flow, send params to next page
    if (this.superClinicId) {
      params['superClinicId'] = this.superClinicId;
    }

    // if singleclinic flow, send clinics params to next page
    if (this.singleClinic === 'true') {
      params['clinics'] = this.preselectedClinic;
    }

    const navigationExtras: NavigationExtras = {
      queryParams: params,
    };

    this.router.navigate(['/privacy-policy'], navigationExtras);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/signup/signup.component.ts